/* Keep Zip's own wording, pricing and modal; limit its trigger to logo/info. */
(() => {
  'use strict';

  const widgetSelector = '.bnpl-messaging .bnpl-messaging__zip[data-zm-widget="popup"]';
  const controlSelector = '.zip-logo, .zip-learn-more';

  function enhanceWidget(widget) {
    widget.querySelectorAll(controlSelector).forEach((control) => {
      // Preserve any native interactive controls introduced by the provider.
      if (control.closest('a, button, input, select, textarea')) return;
      control.setAttribute('role', 'button');
      control.setAttribute('tabindex', '0');
      control.setAttribute('aria-label', 'Learn more about Zip — opens a dialog');
      control.setAttribute('aria-haspopup', 'dialog');
      control.setAttribute('data-bnpl-zip-control', '');
    });
  }

  function enhanceWithin(node) {
    if (!(node instanceof Element)) return;
    const containingWidget = node.closest(widgetSelector);
    if (containingWidget) enhanceWidget(containingWidget);
    node.querySelectorAll(widgetSelector).forEach(enhanceWidget);
  }

  // Capture before Zip's listener on the placement; allow its real logo/info
  // clicks through unchanged. Text selection and other providers are untouched.
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : event.target.parentElement;
    const widget = target?.closest(widgetSelector);
    if (!widget) return;
    const control = target.closest(controlSelector);
    if (control && widget.contains(control)) return;
    event.preventDefault();
    event.stopPropagation();
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const control = event.target instanceof Element
      ? event.target.closest('[data-bnpl-zip-control]')
      : null;
    if (!control?.closest(widgetSelector)) return;
    event.preventDefault();
    if (!event.repeat) control.click();
  }, true);

  enhanceWithin(document.body);
  // Covers delayed provider rendering, variant replacement, cart refresh and
  // Theme Editor section insertion without rebinding event handlers per widget.
  new MutationObserver((records) => {
    const additions = new Set();
    records.forEach((record) => record.addedNodes.forEach((node) => additions.add(node)));
    additions.forEach(enhanceWithin);
  }).observe(document.body, { childList: true, subtree: true });
})();
